import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme/theme';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import SurveyInsights from './pages/SurveyInsights';
import SurveyDashboard from './pages/SurveyDashboard';
import SurveyDataInteraction from './pages/SurveyDataInteraction';
import VendorJourneyPanel from './pages/VendorJourneyPanel';
import Login from './pages/Login';
import './styles/amplify-overrides.css';
import { AWS_REGION, COGNITO_USER_POOL_ID, COGNITO_CLIENT_ID } from './runtimeConfig';

// Configure AWS Amplify v6 with Cognito (values resolved at runtime — see runtimeConfig.js)
console.log('🔧 Configuring Amplify with:', {
  region: AWS_REGION,
  userPoolId: COGNITO_USER_POOL_ID,
  clientId: COGNITO_CLIENT_ID,
});

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: COGNITO_USER_POOL_ID,
      userPoolClientId: COGNITO_CLIENT_ID,
      loginWith: {
        email: true,
        username: false, // Disable username since pool uses email alias
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
});

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/insights"
              element={
                <ProtectedRoute>
                  <SurveyInsights />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <SurveyDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/data-interaction"
              element={
                <ProtectedRoute>
                  <SurveyDataInteraction />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vendor-journey"
              element={
                <ProtectedRoute>
                  <VendorJourneyPanel />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
